import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import http from "@/http-common-admin";
import { useToast } from "vue-toastification";
const toast = useToast();
@Module({ namespaced: true, name: "" })
class Providers extends VuexModule {
  public status!: string;
  public data!: any;
  public error!: object;

  @Mutation
  public onFetching(): void {
    this.status = "fetching";
    this.error = {};
    this.data = [];
  }

  @Mutation
  public onSuccess(data: object): void {
    this.status = "success";
    this.error = {};
    this.data = data;
  }

  @Mutation
  public onError(err: object): void {
    this.status = "error";
    this.error = err;
  }

  @Action({ rawError: true })
  public getProviders() {
    return new Promise((resolve, reject) => {
      this.context.commit("onFetching");
      http
        .get("provider/admin/list")
        .then((response) => {
          this.context.commit("onSuccess", response.data);
          resolve(response);
        })
        .catch((error) => {
          this.context.commit("onError", error);
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  public getProvidersForPairId(pairId: string) {
    return new Promise((resolve, reject) => {
      this.context.commit("onFetching");
      http
        .get("provider/admin/list-for-trade-pair/" + pairId)
        .then((response) => {
          this.context.commit("onSuccess", response.data);
          resolve(response);
        })
        .catch((error) => {
          this.context.commit("onError", error);
          reject(error);
        });
    });
  }

  public get providers(): object {
    return this.data;
  }
}
export default Providers;
